import { render } from "./home-new.vue?vue&type=template&id=8824e08e"
import script from "./home-new.vue?vue&type=script&lang=js"
export * from "./home-new.vue?vue&type=script&lang=js"

import "./home-new.vue?vue&type=style&index=0&id=8824e08e&lang=scss"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/d72e10b2-82a4-4871-b4ef-3f0bf96be7c1/workspace/site-h5_3HZM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__